module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/2@2x_aa9b6758e32f9750826cc289edb3cc7d.png";